(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Point', Point);

    Point.$inject = ['$resource'];

    function Point ($resource) {
        var resourceUrl =  'api/points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
            ,'multiple': {
            	url:'api/points/multiple',
            	method: 'POST'
            },
            'categories': {
            	url:'api/points/categories',
            	isArray: true,
            	method: 'GET'
            },
            'categoryTMG': {
            	url:'api/points/categoryTMG',
            	isArray: true,
            	method: 'GET'
            },
            'export': {
                url:'api/points/export',
                isArray: true,
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'adaptInterventions': {
                url:'api/points/:id/regex/adaptInterventions',
                method: 'POST',
                params: {id: '@id'}
            }
        });
    }
})();
